module.exports = __webpack_public_path__ + "static/media/baa.6a5b1f7b.mp4";